import * as React from 'react'
import {
  CreateButton,
  ExportButton,
  TopToolbar,
  FilterButton,
  useResourceContext,
  useTranslate,
} from 'react-admin'
import {
  PostFilterButtonReservation,
  PostFilterFormReservation,
} from 'src/components/uiElements/CRUD/PostFilterButtonReservation'
import { PostFilterButtonUser, PostFilterFormUser } from 'src/components/uiElements/CRUD/PostFilterButtonUser'
import { Box, CircularProgress } from '@mui/material'
import { UpdateRuleView } from '../buttons/UpdateRulesViews'

export const ListViewTopToolbar = ({
  hasCreate,
  listFilters,
  customFilter = false,
  loadingExport = false,
  exporterDisable = false,
  updateRuleView = false,
  FilterButtonComponent = null,
  FilterFormComponent = null,
  CustomExportButton = null,
  CustomImportButton= null
}) => {
  const translate = useTranslate()
  const resource = useResourceContext()
  const [exportLoading, setExportLoading] = React.useState(false)

  const getCreateLabel = () => {
    const label = resource === 'payment-entity' ? 'generate_payment' : 'create'
    return translate(`ra.action.${label}`)
  }

  const getFilter = (resource, customFilter, FilterButtonComponent) => {
    try {
      if (FilterButtonComponent) return <FilterButtonComponent listFilters={listFilters} />

      if (!customFilter) return <FilterButton />

      if (resource == 'reservation') return <PostFilterButtonReservation listFilters={listFilters} />

      if (resource == 'userB2') return <PostFilterButtonUser listFilters={listFilters} />
    } catch (error) {
      return <FilterButton />
    }
  }

  const getFormFilter = (resource, customFilter, FilterFormComponent) => {
    try {
      if (FilterFormComponent) return <FilterFormComponent />

      if (!customFilter) return null

      if (resource == 'reservation') return <PostFilterFormReservation />

      if (resource == 'userB2') return <PostFilterFormUser />

      return null
    } catch (error) {
      return null
    }
  }

  const setTimeoutFunction = () =>{
    setExportLoading(true)
    setTimeout(() => {
      setExportLoading(false);
    }, 10000)
  }

  return (
    <Box style={customFilter || FilterFormComponent ? { width: '100%' } : {}}>
      <TopToolbar>
        {getFilter(resource, customFilter, FilterButtonComponent)}
        {hasCreate && <CreateButton label={getCreateLabel()} />}
        {!exporterDisable ? (
          loadingExport ? (
            <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CircularProgress size={20} />
              <ExportButton disabled={true} />
            </Box>
          ) : (
            <ExportButton disabled={exportLoading}  onClick={setTimeoutFunction}/>
          )
        ) : null}
        {CustomImportButton && <CustomImportButton />}
        {CustomExportButton && <CustomExportButton />}
        {updateRuleView && <UpdateRuleView />}
      </TopToolbar>
      {getFormFilter(resource, customFilter, FilterFormComponent)}
    </Box>
  )
}
